module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/banner-152033077c7bae27a78900a7e2a0b07b.png";